<template lang="pug">
yz-dialog(v-model="showDialog" persistent max-width="540px")
  yz-card
    yz-dialog-normal-header(title="New interface update" @close="showDialog = false")
    .px-6.py-6
      .d-flex.align-center
        v-icon.mr-3(size="20" color="danger500") $yzi-alert-circle-solid
        div
          .yz-medium-body-md.font-semibold.text-neutral-700 The current interface you're using is expiring soon.
      .yz-regular-body-sm.text-neutral-700.mt-2
        | Switch to the new interface before&nbsp;
        span.font-semibold 31 July 2026
        | . After that, the previous interface will no longer be available.
    yz-dialog-normal-actions(cancel-label="Remind me later" save-label="Learn more" @cancel="showDialog = false" @save="onLearnMore")
</template>

<script>
export default {
  name: 'InterfaceUpdateDialog',
  props: {
    open: { type: Boolean, default: false }
  },
  computed: {
    showDialog: {
      get () { return this.open },
      set (val) { this.$emit('update:open', val) }
    }
  },
  methods: {
    onLearnMore () {
      this.$emit('learnMore')
      this.showDialog = false
    }
  }
}
</script>
